<template>
  <div class="story-wrapper">
    <div
      class="fb-story-frame"
      :style="{
        backgroundImage: `url(${post?.file?.preview})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }"
    >
      <!-- Top Header -->
      <div
        class="story-header d-flex justify-space-between align-center px-3 pt-2"
      >
        <div class="d-flex align-center">
          <v-avatar size="28" class="me-2">
            <img src="https://i.pravatar.cc/300" />
          </v-avatar>
          <div>
            <span class="text-white font-weight-bold d-block">Vish Patil</span>
            <span class="text-white text-caption">4h • 🎵 Neha Kakkar</span>
          </div>
        </div>
        <v-icon class="text-white">mdi-dots-horizontal</v-icon>
      </div>

      <!-- Story Image -->
      <video
        v-if="
          post?.file?.file &&
          post?.file?.file?.type &&
          post?.file?.file?.type.startsWith('video/')
        "
        width="100%"
        :src="post?.file?.preview"
        autoplay
        muted
        loop
      ></video>

      <!-- Bottom Controls -->
      <div
        class="story-footer d-flex justify-space-between align-center px-3 pb-2"
      >
        <img src="@/assets/images/bottomfacebookstory.png" class="w-100" />
      </div>
    </div>
  </div>
</template>

<script>
import { publishPost } from "@/store/publishPost/publishPost.js";
export default {
  name: "FacebookStoryReview",
  components: {},
  data() {
    return {
      store: publishPost(),
      post: {},
    };
  },
  watch: {
    "store.getCarouselSlider": {
      handler() {
        this.post = this.store.post["facebook"].find(
          (item) => item.type === "story"
        );
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.story-wrapper {
  width: 100%;
  max-width: 420px;
  aspect-ratio: 9 / 16;
  margin: auto;
  position: relative;
}

.fb-story-frame {
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  background-color: black;
}

/* Header Overlay */
.story-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6), transparent);
}

/* Footer Overlay */
.story-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  padding-top: 10px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
}

.send-btn {
  color: black !important;
  font-weight: 500;
  font-size: 13px;
}

.emoji-icon {
  background: white;
  border-radius: 50%;
  padding: 4px;
}
</style>
